export const logoNegative = ['608 134', ``]